import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'SSNField'
},
  __name: 'SSNField',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {



const model = _useModel<string | null>(__props, "modelValue")

const onUpdate = (updatedSSN: string | null) => {
  if (updatedSSN) {
    model.value = updatedSSN.toUpperCase()
  } else {
    model.value = updatedSSN
  }
}

return (_ctx: any,_cache: any) => {
  const _component_VTextField = _resolveComponent("VTextField")!

  return (_openBlock(), _createBlock(_component_VTextField, {
    label: _ctx.$t('form.label.ssn'),
    autocomplete: "off",
    "model-value": model.value,
    "onUpdate:modelValue": onUpdate
  }, null, 8, ["label", "model-value"]))
}
}

})